/**
 * Является ли пользователь автором поста
 */
export const isOwner = (authorId?: number, userId?: number) => {
  return Boolean(authorId && userId && authorId === userId);
};
